import React from 'react';
import { Farmer } from '../../types/farmers';
import { Agent } from '../../types/agent';
import { Lab } from '../../types/lab';
import FarmerDialog from '../Farmers/FarmerDialog';
import AgentDialog from '../LookupTables/Agents/AgentDialog';
import LabDialog from '../LookupTables/Labs/LabDialog';

type EditingEntity =
  | { type: 'Farmer'; data: Farmer }
  | { type: 'Agent'; data: Agent }
  | { type: 'Lab'; data: Lab };

interface EntityEditDialogsProps {
  /** The entity currently being edited (null when no dialog is open) */
  editingEntity: EditingEntity | null;
  /** Called when the dialog closes — receives whether a save occurred */
  onClose: (saved: boolean) => void;
  /** Optional tab index to open the dialog on */
  initialTab?: number;
}

/**
 * EntityEditDialogs Component
 *
 * Renders the correct edit dialog (FarmerDialog, AgentDialog, or LabDialog)
 * based on the discriminated union type of the editing entity.
 *
 * Used by EntityAssignmentsSection (workflow detail) to keep the dialog rendering block in one place.
 */
export const EntityEditDialogs: React.FC<EntityEditDialogsProps> = ({
  editingEntity,
  onClose,
  initialTab,
}) => {
  if (!editingEntity) return null;

  switch (editingEntity.type) {
    case 'Farmer':
      return (
        <FarmerDialog
          open
          farmer={editingEntity.data}
          onClose={onClose}
          initialTab={initialTab}
        />
      );
    case 'Agent':
      return (
        <AgentDialog
          open
          agent={editingEntity.data}
          onClose={onClose}
          initialTab={initialTab}
        />
      );
    case 'Lab':
      return (
        <LabDialog
          open
          lab={editingEntity.data}
          onClose={onClose}
          initialTab={initialTab}
        />
      );
  }
};

export default EntityEditDialogs;
